export const UPDATE_CALENDAR_SUCCESS = 'UPDATE_CALENDAR_SUCCESS'
export const UPDATE_CALENDAR_FAILED = 'UPDATE_CALENDAR_FAILED'
export const UPDATE_CALENDAR_START = 'UPDATE_CALENDAR_START'

export const updateCalendarSuccess = data => ({
	type: UPDATE_CALENDAR_SUCCESS,
	data,
})

export const updateCalendarFailed = () => ({
	type: UPDATE_CALENDAR_FAILED,
})

export const updateCalendarStart = () => ({
	type: UPDATE_CALENDAR_START,
})

export const updateCalendar = () => (dispatch, getState, {fetchCalendar}) => {
	dispatch(updateCalendarStart())
	return fetchCalendar()
		.then(data => dispatch(updateCalendarSuccess(data)))
		.catch(() => dispatch(updateCalendarFailed()))
}



// WEBPACK FOOTER //
// ./src/actions/calendar.js